import React from "react";
import { motion } from "framer-motion";
import { AlertTriangle } from "lucide-react";

// In-app confirmation dialog matching this app's own modal styling — replaces the browser's
// native window.confirm(), which doesn't follow the app's design language at all.
const ConfirmModal = ({ title, message, confirmLabel = "Confirm", danger = false, onConfirm, onCancel }) => (
    <motion.div
        className="fixed inset-0 z-[1100] bg-black/40 flex items-center justify-center px-fluid-3 py-fluid-3"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
    >
        <motion.div
            className="bg-white rounded-2xl shadow-xl w-full max-w-[440px] p-fluid-4 space-y-fluid-3"
            initial={{ scale: 0.95 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.95 }}
        >
            <div className="flex flex-col items-center space-y-fluid-2">
                <div className={`rounded-full p-fluid-2 text-white ${danger ? "bg-red-600" : "bg-[#1e2a74]"}`}>
                    <AlertTriangle size={26} />
                </div>
                <h2 className="text-fluid-lg font-semibold text-[#111827] text-center">{title}</h2>
                <p className="text-fluid-sm text-gray-600 text-center">{message}</p>
            </div>

            <div className="flex justify-end gap-fluid-2 pt-fluid-2 border-t border-gray-200">
                <button
                    onClick={onCancel}
                    className="px-fluid-button-x py-fluid-button-y border border-gray-300 rounded text-gray-700 hover:bg-gray-100 text-fluid-sm"
                >
                    Cancel
                </button>
                <button
                    onClick={onConfirm}
                    className={`px-fluid-button-x py-fluid-button-y text-fluid-sm rounded font-semibold text-white ${
                        danger ? "bg-red-600 hover:bg-red-700" : "bg-[#1e2a74] hover:bg-[#18225c]"
                    }`}
                >
                    {confirmLabel}
                </button>
            </div>
        </motion.div>
    </motion.div>
);

export default ConfirmModal;
